module.exports = __webpack_public_path__ + "static/curriculo-d228b88f5dcaff7cc758d0ee5745e6da.pdf";